const BASE_URL = "http://localhost:3100";
// const BASE_URL = process.env.REACT_APP_API_URL;

export async function getMessages() {
  const res = await fetch(`${BASE_URL}/admin/messagesall`);
  return res?.json();
}

export async function createMessage(data) {
  const res = await fetch(`${BASE_URL}/admin/message`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });

  return res.json();
}

export async function closeMessage(id) {
  const res = await fetch(`${BASE_URL}/admin/message/close/${id}`, {
    method: "PUT",
  });

  return res.json();
}
